// @ts-nocheck
import React from 'react';
import { ApplyPluginsType, dynamic } from '/home/gitlab-runner/builds/QXiX3rkE/0/bluevision/bv_crm_web/node_modules/umi/node_modules/@umijs/runtime';
import * as umiExports from './umiExports';
import { plugin } from './plugin';
import LoadingComponent from '@ant-design/pro-layout/es/PageLoading';

export function getRoutes() {
  const routes = [
  {
    "path": "/",
    "component": dynamic({ loader: () => import(/* webpackChunkName: 't__plugin-layout__Layout' */'/home/gitlab-runner/builds/QXiX3rkE/0/bluevision/bv_crm_web/src/.umi-production/plugin-layout/Layout.tsx'), loading: LoadingComponent}),
    "routes": [
      {
        "path": "/",
        "redirect": "/basic/signature",
        "exact": true
      },
      {
        "path": "/user",
        "layout": false,
        "routes": [
          {
            "path": "/user",
            "routes": [
              {
                "name": "login",
                "path": "/user/login",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Administration__Login' */'/home/gitlab-runner/builds/QXiX3rkE/0/bluevision/bv_crm_web/src/pages/Administration/Login'), loading: LoadingComponent}),
                "exact": true
              }
            ]
          }
        ]
      },
      {
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'components__Framework__Layout__BasicLayout' */'/home/gitlab-runner/builds/QXiX3rkE/0/bluevision/bv_crm_web/src/components/Framework/Layout/BasicLayout'), loading: LoadingComponent}),
        "flatMenu": true,
        "routes": [
          {
            "path": "/administration",
            "redirect": "/administration/menu",
            "exact": true
          },
          {
            "path": "/analysis",
            "redirect": "/analysis/bv-data-import",
            "exact": true
          },
          {
            "path": "/application",
            "redirect": "/initiate-application",
            "exact": true
          },
          {
            "path": "/basic",
            "redirect": "/basic/signature",
            "exact": true
          },
          {
            "path": "/finance",
            "redirect": "/finance/bill",
            "exact": true
          },
          {
            "path": "/industry",
            "redirect": "/industry/game",
            "exact": true
          },
          {
            "path": "/kanban",
            "redirect": "/kanban/bv-spend-analysis",
            "exact": true
          },
          {
            "path": "/sale",
            "redirect": "/sale/sale-team",
            "exact": true
          },
          {
            "path": "/tools",
            "redirect": "/tools/task-center",
            "exact": true
          },
          {
            "path": "/quotoManage",
            "redirect": "/quotoManage/quoto",
            "exact": true
          },
          {
            "path": "/monitor",
            "redirect": "/monitor/allocation-consumption-limit",
            "exact": true
          },
          {
            "path": "/newMedia",
            "redirect": "/media-asset/new-media-apply",
            "exact": true
          },
          {
            "name": "基础数据",
            "path": "/basic",
            "icon": "carryOut",
            "routes": [
              {
                "name": "VL用户列表",
                "access": "routeFilter",
                "path": "/basic/users",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Basic__VL__Users' */'/home/gitlab-runner/builds/QXiX3rkE/0/bluevision/bv_crm_web/src/pages/Basic/VL/Users'), loading: LoadingComponent}),
                "exact": true
              },
              {
                "name": "人员管理",
                "access": "routeFilter",
                "hideInMenu": true,
                "path": "/basic/users/:vlId",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Basic__VL__PersonnelManage' */'/home/gitlab-runner/builds/QXiX3rkE/0/bluevision/bv_crm_web/src/pages/Basic/VL/PersonnelManage'), loading: LoadingComponent}),
                "exact": true
              },
              {
                "name": "VL账号列表",
                "access": "routeFilter",
                "path": "/basic/accounts",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Basic__VL__Accounts' */'/home/gitlab-runner/builds/QXiX3rkE/0/bluevision/bv_crm_web/src/pages/Basic/VL/Accounts'), loading: LoadingComponent}),
                "exact": true
              },
              {
                "name": "结算主体",
                "access": "routeFilter",
                "path": "/basic/settlement",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Basic__Settlement' */'/home/gitlab-runner/builds/QXiX3rkE/0/bluevision/bv_crm_web/src/pages/Basic/Settlement'), loading: LoadingComponent}),
                "exact": true
              },
              {
                "name": "客户集团",
                "access": "routeFilter",
                "path": "/basic/client-group",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Basic__ClientGroup' */'/home/gitlab-runner/builds/QXiX3rkE/0/bluevision/bv_crm_web/src/pages/Basic/ClientGroup'), loading: LoadingComponent}),
                "exact": true
              },
              {
                "name": "客户集团详情",
                "path": "/basic/client-group/detail",
                "access": "routeFilter",
                "hideInMenu": true,
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Basic__ClientGroup__Detail' */'/home/gitlab-runner/builds/QXiX3rkE/0/bluevision/bv_crm_web/src/pages/Basic/ClientGroup/Detail'), loading: LoadingComponent}),
                "exact": true
              },
              {
                "name": "签约信息",
                "access": "routeFilter",
                "path": "/basic/signature",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Basic__Signature' */'/home/gitlab-runner/builds/QXiX3rkE/0/bluevision/bv_crm_web/src/pages/Basic/Signature'), loading: LoadingComponent}),
                "exact": true
              },
              {
                "name": "合同条款",
                "access": "routeFilter",
                "path": "/basic/contract",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Basic__Contract' */'/home/gitlab-runner/builds/QXiX3rkE/0/bluevision/bv_crm_web/src/pages/Basic/Contract'), loading: LoadingComponent}),
                "exact": true
              },
              {
                "name": "欠款管理",
                "access": "routeFilter",
                "path": "/basic/arrears",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Basic__Arrears' */'/home/gitlab-runner/builds/QXiX3rkE/0/bluevision/bv_crm_web/src/pages/Basic/Arrears'), loading: LoadingComponent}),
                "exact": true
              },
              {
                "name": "广告账户",
                "access": "routeFilter",
                "path": "/basic/bv-account",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Basic__Account__Bluevision' */'/home/gitlab-runner/builds/QXiX3rkE/0/bluevision/bv_crm_web/src/pages/Basic/Account/Bluevision'), loading: LoadingComponent}),
                "exact": true
              },
              {
                "name": "大盘广告账户",
                "access": "routeFilter",
                "path": "/basic/entirety-account",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Basic__Account__Entirety' */'/home/gitlab-runner/builds/QXiX3rkE/0/bluevision/bv_crm_web/src/pages/Basic/Account/Entirety'), loading: LoadingComponent}),
                "exact": true
              },
              {
                "name": "大盘季度目标",
                "access": "routeFilter",
                "path": "/basic/entirety-target",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Basic__Target' */'/home/gitlab-runner/builds/QXiX3rkE/0/bluevision/bv_crm_web/src/pages/Basic/Target'), loading: LoadingComponent}),
                "exact": true
              },
              {
                "name": "媒体Churn Rate",
                "access": "routeFilter",
                "path": "/basic/churn-rate",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Basic__MediaChurnRate' */'/home/gitlab-runner/builds/QXiX3rkE/0/bluevision/bv_crm_web/src/pages/Basic/MediaChurnRate'), loading: LoadingComponent}),
                "exact": true
              },
              {
                "name": "原始合同数据",
                "access": "routeFilter",
                "path": "/basic/original-contract",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Basic__OriginalContract' */'/home/gitlab-runner/builds/QXiX3rkE/0/bluevision/bv_crm_web/src/pages/Basic/OriginalContract'), loading: LoadingComponent}),
                "exact": true
              },
              {
                "name": "原始合同数据详情",
                "access": "routeFilter",
                "hideInMenu": true,
                "path": "/basic/original-contract/:id",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Basic__OriginalContract__Detail' */'/home/gitlab-runner/builds/QXiX3rkE/0/bluevision/bv_crm_web/src/pages/Basic/OriginalContract/Detail'), loading: LoadingComponent}),
                "exact": true
              }
            ]
          },
          {
            "name": "销售管理",
            "path": "/sale",
            "icon": "carryOut",
            "routes": [
              {
                "name": "销售团队",
                "access": "routeFilter",
                "path": "/sale/team",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Sale__Team' */'/home/gitlab-runner/builds/QXiX3rkE/0/bluevision/bv_crm_web/src/pages/Sale/Team'), loading: LoadingComponent}),
                "exact": true
              },
              {
                "name": "销售目标",
                "access": "routeFilter",
                "path": "/sale/target",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Sale__Target' */'/home/gitlab-runner/builds/QXiX3rkE/0/bluevision/bv_crm_web/src/pages/Sale/Target'), loading: LoadingComponent}),
                "exact": true
              }
            ]
          },
          {
            "name": "对账结算",
            "path": "/finance",
            "icon": "calculator",
            "routes": [
              {
                "name": "返点结算",
                "access": "routeFilter",
                "path": "/finance/rebate-manage",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Finance__RebateManage' */'/home/gitlab-runner/builds/QXiX3rkE/0/bluevision/bv_crm_web/src/pages/Finance/RebateManage'), loading: LoadingComponent}),
                "exact": true
              },
              {
                "name": "返点明细",
                "path": "/finance/rebate-manage/detail/:type/:rebate_id",
                "hideInMenu": true,
                "access": "routeFilter",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Finance__RebateManage__Detail' */'/home/gitlab-runner/builds/QXiX3rkE/0/bluevision/bv_crm_web/src/pages/Finance/RebateManage/Detail'), loading: LoadingComponent}),
                "exact": true
              },
              {
                "name": "返点结算导入",
                "access": "routeFilter",
                "hideInMenu": true,
                "path": "/finance/rebate-manage/rebate-import/:type",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Finance__RebateManage__Import' */'/home/gitlab-runner/builds/QXiX3rkE/0/bluevision/bv_crm_web/src/pages/Finance/RebateManage/Import'), loading: LoadingComponent}),
                "exact": true
              },
              {
                "name": "账单",
                "access": "routeFilter",
                "path": "/finance/bill",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Finance__Bill' */'/home/gitlab-runner/builds/QXiX3rkE/0/bluevision/bv_crm_web/src/pages/Finance/Bill'), loading: LoadingComponent}),
                "exact": true
              },
              {
                "name": "新兴媒体账单",
                "access": "routeFilter",
                "path": "/finance/media-bill",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Finance__MediaBill' */'/home/gitlab-runner/builds/QXiX3rkE/0/bluevision/bv_crm_web/src/pages/Finance/MediaBill'), loading: LoadingComponent}),
                "exact": true
              },
              {
                "name": "所有发票",
                "access": "routeFilter",
                "path": "/finance/all-invoice",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Finance__AllInvoice' */'/home/gitlab-runner/builds/QXiX3rkE/0/bluevision/bv_crm_web/src/pages/Finance/AllInvoice'), loading: LoadingComponent}),
                "exact": true
              }
            ]
          },
          {
            "name": "TikTok开户",
            "path": "/tiktokProcess",
            "icon": "idcard",
            "routes": [
              {
                "name": "TikTok全量开户",
                "access": "routeFilter",
                "path": "/tiktokProcess/total",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__TiktokProcess__Total__MainPage' */'/home/gitlab-runner/builds/QXiX3rkE/0/bluevision/bv_crm_web/src/pages/TiktokProcess/Total/MainPage'), loading: LoadingComponent}),
                "exact": true
              },
              {
                "name": "TikTok开户审核",
                "access": "routeFilter",
                "path": "/tiktokProcess/review",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__TiktokProcess__Review__MainPage' */'/home/gitlab-runner/builds/QXiX3rkE/0/bluevision/bv_crm_web/src/pages/TiktokProcess/Review/MainPage'), loading: LoadingComponent}),
                "exact": true
              },
              {
                "name": "BC维护",
                "access": "routeFilter",
                "path": "/tiktokProcess/bcid",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__TiktokProcess__Bcid__MainPage' */'/home/gitlab-runner/builds/QXiX3rkE/0/bluevision/bv_crm_web/src/pages/TiktokProcess/Bcid/MainPage'), loading: LoadingComponent}),
                "exact": true
              }
            ]
          },
          {
            "name": "Microsoft开户",
            "path": "/microsoftProcess",
            "icon": "medium",
            "routes": [
              {
                "name": "Microsoft全量开户",
                "access": "routeFilter",
                "path": "/microsoftProcess/total",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__MicrosoftProcess__Total' */'/home/gitlab-runner/builds/QXiX3rkE/0/bluevision/bv_crm_web/src/pages/MicrosoftProcess/Total'), loading: LoadingComponent}),
                "exact": true
              },
              {
                "name": "Microsoft开户审核",
                "access": "routeFilter",
                "path": "/microsoftProcess/review",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__MicrosoftProcess__Review' */'/home/gitlab-runner/builds/QXiX3rkE/0/bluevision/bv_crm_web/src/pages/MicrosoftProcess/Review'), loading: LoadingComponent}),
                "exact": true
              },
              {
                "name": "CID管理",
                "access": "routeFilter",
                "path": "/microsoftProcess/management",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__MicrosoftProcess__CIDManagement' */'/home/gitlab-runner/builds/QXiX3rkE/0/bluevision/bv_crm_web/src/pages/MicrosoftProcess/CIDManagement'), loading: LoadingComponent}),
                "exact": true
              },
              {
                "name": "CID申请",
                "access": "routeFilter",
                "path": "/microsoftProcess/apply",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__MicrosoftProcess__CIDApply' */'/home/gitlab-runner/builds/QXiX3rkE/0/bluevision/bv_crm_web/src/pages/MicrosoftProcess/CIDApply'), loading: LoadingComponent}),
                "exact": true
              }
            ]
          },
          {
            "name": "Snapchat开户",
            "path": "/snapchatProcess",
            "icon": "switcher",
            "routes": [
              {
                "name": "Snapchat全量开户",
                "access": "routeFilter",
                "path": "/snapchatProcess/total",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__SnapchatProcess__Total' */'/home/gitlab-runner/builds/QXiX3rkE/0/bluevision/bv_crm_web/src/pages/SnapchatProcess/Total'), loading: LoadingComponent}),
                "exact": true
              }
            ]
          },
          {
            "name": "OpenAI开户",
            "path": "/openaiProcess",
            "icon": "switcher",
            "routes": [
              {
                "name": "OpenAI全量开户",
                "access": "routeFilter",
                "path": "/openaiProcess/total",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__OpenaiProcess__Total' */'/home/gitlab-runner/builds/QXiX3rkE/0/bluevision/bv_crm_web/src/pages/OpenaiProcess/Total'), loading: LoadingComponent}),
                "exact": true
              }
            ]
          },
          {
            "name": "媒体资产",
            "path": "/media-asset",
            "icon": "CodeOutlined",
            "routes": [
              {
                "name": "媒体管理",
                "access": "routeFilter",
                "path": "/media-asset/media-management",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__MediaAsset__MediaManagement' */'/home/gitlab-runner/builds/QXiX3rkE/0/bluevision/bv_crm_web/src/pages/MediaAsset/MediaManagement'), loading: LoadingComponent}),
                "exact": true
              },
              {
                "name": "新兴媒体开户",
                "access": "routeFilter",
                "path": "/media-asset/new-media-apply",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__NewMedia' */'/home/gitlab-runner/builds/QXiX3rkE/0/bluevision/bv_crm_web/src/pages/NewMedia'), loading: LoadingComponent}),
                "exact": true
              },
              {
                "name": "新兴媒体开户申请",
                "path": "/media-asset/new-media-apply-submit",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__NewMedia__Apply' */'/home/gitlab-runner/builds/QXiX3rkE/0/bluevision/bv_crm_web/src/pages/NewMedia/Apply'), loading: LoadingComponent}),
                "hideInMenu": true,
                "exact": true
              },
              {
                "name": "新兴媒体开户表单",
                "path": "/media-asset/new-media-apply-form",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__MediaAsset__MediaManagement__NewMediaApplyForm' */'/home/gitlab-runner/builds/QXiX3rkE/0/bluevision/bv_crm_web/src/pages/MediaAsset/MediaManagement/NewMediaApplyForm'), loading: LoadingComponent}),
                "hideInMenu": true,
                "exact": true
              }
            ]
          },
          {
            "name": "财务管理",
            "path": "/wallet",
            "icon": "dollar",
            "routes": [
              {
                "name": "钱包管理",
                "access": "routeFilter",
                "path": "/wallet/wallet",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Wallet__Wallet' */'/home/gitlab-runner/builds/QXiX3rkE/0/bluevision/bv_crm_web/src/pages/Wallet/Wallet'), loading: LoadingComponent}),
                "exact": true
              },
              {
                "name": "钱包变更",
                "access": "routeFilter",
                "path": "/wallet/wallet-change",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Wallet__WalletChange' */'/home/gitlab-runner/builds/QXiX3rkE/0/bluevision/bv_crm_web/src/pages/Wallet/WalletChange'), loading: LoadingComponent}),
                "exact": true
              },
              {
                "name": "水单管理",
                "access": "routeFilter",
                "path": "/wallet/advance-payment",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Wallet__AdvancePayment' */'/home/gitlab-runner/builds/QXiX3rkE/0/bluevision/bv_crm_web/src/pages/Wallet/AdvancePayment'), loading: LoadingComponent}),
                "exact": true
              },
              {
                "name": "钱包额度管理",
                "access": "routeFilter",
                "path": "/wallet/quota",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Wallet__Quota' */'/home/gitlab-runner/builds/QXiX3rkE/0/bluevision/bv_crm_web/src/pages/Wallet/Quota'), loading: LoadingComponent}),
                "exact": true
              },
              {
                "name": "VA 管理",
                "access": "routeFilter",
                "path": "/wallet/va",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Wallet__VA' */'/home/gitlab-runner/builds/QXiX3rkE/0/bluevision/bv_crm_web/src/pages/Wallet/VA'), loading: LoadingComponent}),
                "exact": true
              },
              {
                "name": "第三方到账提现",
                "access": "routeFilter",
                "path": "/wallet/withdraw-deposit",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Wallet__WithdrawDeposit' */'/home/gitlab-runner/builds/QXiX3rkE/0/bluevision/bv_crm_web/src/pages/Wallet/WithdrawDeposit'), loading: LoadingComponent}),
                "exact": true
              }
            ]
          },
          {
            "name": "额度管理",
            "path": "/quotoManage",
            "icon": "FormOutlined",
            "access": "routeFilter",
            "routes": [
              {
                "name": "信用卡额度管理",
                "path": "/quotoManage/quoto",
                "access": "routeFilter",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__QuotaManage' */'/home/gitlab-runner/builds/QXiX3rkE/0/bluevision/bv_crm_web/src/pages/QuotaManage'), loading: LoadingComponent}),
                "exact": true
              },
              {
                "name": "信用卡余额调整",
                "path": "/quotoManage/adjust",
                "access": "routeFilter",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__QuotaManage__SubPage__InitBalanceAdjust' */'/home/gitlab-runner/builds/QXiX3rkE/0/bluevision/bv_crm_web/src/pages/QuotaManage/SubPage/InitBalanceAdjust'), loading: LoadingComponent}),
                "exact": true
              },
              {
                "name": "信用卡余额信息",
                "path": "/quotoManage/adjust/detail",
                "access": "routeFilter",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__QuotaManage__SubPage__InitBalanceAdjust__balanceInfo' */'/home/gitlab-runner/builds/QXiX3rkE/0/bluevision/bv_crm_web/src/pages/QuotaManage/SubPage/InitBalanceAdjust/balanceInfo'), loading: LoadingComponent}),
                "hideInMenu": true,
                "exact": true
              }
            ]
          },
          {
            "name": "业务申请",
            "path": "/application",
            "icon": "diff",
            "routes": [
              {
                "name": "发起申请",
                "access": "routeFilter",
                "path": "/application/initiate",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Application__Initiate' */'/home/gitlab-runner/builds/QXiX3rkE/0/bluevision/bv_crm_web/src/pages/Application/Initiate'), loading: LoadingComponent}),
                "exact": true
              },
              {
                "name": "我的申请",
                "access": "routeFilter",
                "path": "/application/mine",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Application__Mine' */'/home/gitlab-runner/builds/QXiX3rkE/0/bluevision/bv_crm_web/src/pages/Application/Mine'), loading: LoadingComponent}),
                "exact": true
              },
              {
                "name": "待审批",
                "access": "routeFilter",
                "path": "/application/review",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Application__Review' */'/home/gitlab-runner/builds/QXiX3rkE/0/bluevision/bv_crm_web/src/pages/Application/Review'), loading: LoadingComponent}),
                "exact": true
              },
              {
                "name": "被封池账户",
                "access": "blockedPool",
                "path": "/application/banned-pool",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Application__BannedPool' */'/home/gitlab-runner/builds/QXiX3rkE/0/bluevision/bv_crm_web/src/pages/Application/BannedPool'), loading: LoadingComponent}),
                "exact": true
              }
            ]
          },
          {
            "name": "新兴媒体批处理",
            "path": "/mediaBatch",
            "icon": "schedule",
            "routes": [
              {
                "name": "额度管理",
                "access": "routeFilter",
                "path": "/mediaBatch/recharge",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__SmallMediaBatch__Recharge' */'/home/gitlab-runner/builds/QXiX3rkE/0/bluevision/bv_crm_web/src/pages/SmallMediaBatch/Recharge'), loading: LoadingComponent}),
                "exact": true
              },
              {
                "name": "绑定",
                "access": "routeFilter",
                "path": "/mediaBatch/bind",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__SmallMediaBatch__Bind' */'/home/gitlab-runner/builds/QXiX3rkE/0/bluevision/bv_crm_web/src/pages/SmallMediaBatch/Bind'), loading: LoadingComponent}),
                "exact": true
              },
              {
                "name": "更名",
                "access": "routeFilter",
                "path": "/mediaBatch/rename",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__SmallMediaBatch__Rename' */'/home/gitlab-runner/builds/QXiX3rkE/0/bluevision/bv_crm_web/src/pages/SmallMediaBatch/Rename'), loading: LoadingComponent}),
                "exact": true
              },
              {
                "name": "其他",
                "access": "routeFilter",
                "path": "/mediaBatch/other",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__SmallMediaBatch__Other' */'/home/gitlab-runner/builds/QXiX3rkE/0/bluevision/bv_crm_web/src/pages/SmallMediaBatch/Other'), loading: LoadingComponent}),
                "exact": true
              }
            ]
          },
          {
            "name": "Tiktok批处理",
            "path": "/tiktokBatch",
            "icon": "schedule",
            "routes": [
              {
                "name": "额度管理",
                "access": "routeFilter",
                "path": "/tiktokBatch/recharge",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__TiktokBatch__Recharge' */'/home/gitlab-runner/builds/QXiX3rkE/0/bluevision/bv_crm_web/src/pages/TiktokBatch/Recharge'), loading: LoadingComponent}),
                "exact": true
              },
              {
                "name": "更名",
                "access": "routeFilter",
                "path": "/tiktokBatch/rename",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__TiktokBatch__Rename' */'/home/gitlab-runner/builds/QXiX3rkE/0/bluevision/bv_crm_web/src/pages/TiktokBatch/Rename'), loading: LoadingComponent}),
                "exact": true
              },
              {
                "name": "绑定BC",
                "access": "routeFilter",
                "path": "/tiktokBatch/bcid",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__TiktokBatch__Bcid' */'/home/gitlab-runner/builds/QXiX3rkE/0/bluevision/bv_crm_web/src/pages/TiktokBatch/Bcid'), loading: LoadingComponent}),
                "exact": true
              },
              {
                "name": "绑定邮箱",
                "access": "routeFilter",
                "path": "/tiktokBatch/email",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__TiktokBatch__Email' */'/home/gitlab-runner/builds/QXiX3rkE/0/bluevision/bv_crm_web/src/pages/TiktokBatch/Email'), loading: LoadingComponent}),
                "exact": true
              }
            ]
          },
          {
            "name": "Microsoft账户运营",
            "path": "/microsoftBatch",
            "icon": "medium",
            "routes": [
              {
                "name": "额度管理",
                "access": "routeFilter",
                "path": "/microsoftBatch/recharge",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__MicrosoftBatch__Recharge' */'/home/gitlab-runner/builds/QXiX3rkE/0/bluevision/bv_crm_web/src/pages/MicrosoftBatch/Recharge'), loading: LoadingComponent}),
                "exact": true
              },
              {
                "name": "绑定邮箱",
                "access": "routeFilter",
                "path": "/microsoftBatch/email",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__MicrosoftBatch__Email' */'/home/gitlab-runner/builds/QXiX3rkE/0/bluevision/bv_crm_web/src/pages/MicrosoftBatch/Email'), loading: LoadingComponent}),
                "exact": true
              }
            ]
          },
          {
            "name": "数据分析",
            "path": "/analysis",
            "icon": "bar-chart",
            "routes": [
              {
                "name": "BV数据导入",
                "access": "routeFilter",
                "path": "/analysis/bv",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Analysis__DataImport__Bluevision' */'/home/gitlab-runner/builds/QXiX3rkE/0/bluevision/bv_crm_web/src/pages/Analysis/DataImport/Bluevision'), loading: LoadingComponent}),
                "exact": true
              },
              {
                "name": "大盘数据导入",
                "access": "routeFilter",
                "path": "/analysis/entirety",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Analysis__DataImport__Entirety' */'/home/gitlab-runner/builds/QXiX3rkE/0/bluevision/bv_crm_web/src/pages/Analysis/DataImport/Entirety'), loading: LoadingComponent}),
                "exact": true
              },
              {
                "name": "结算主体账户使用率",
                "access": "routeFilter",
                "path": "/analysis/settlement",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Analysis__AccountUtilization__Settlement' */'/home/gitlab-runner/builds/QXiX3rkE/0/bluevision/bv_crm_web/src/pages/Analysis/AccountUtilization/Settlement'), loading: LoadingComponent}),
                "exact": true
              },
              {
                "name": "分子分母池",
                "access": "routeFilter",
                "path": "/analysis/fractional",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Analysis__FractionalPool' */'/home/gitlab-runner/builds/QXiX3rkE/0/bluevision/bv_crm_web/src/pages/Analysis/FractionalPool'), loading: LoadingComponent}),
                "exact": true
              },
              {
                "name": "非分母主体池",
                "access": "routeFilter",
                "path": "/analysis/denominator",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Analysis__NonDenominator' */'/home/gitlab-runner/builds/QXiX3rkE/0/bluevision/bv_crm_web/src/pages/Analysis/NonDenominator'), loading: LoadingComponent}),
                "exact": true
              }
            ]
          },
          {
            "name": "数据看板",
            "path": "/kanban",
            "icon": "area-chart",
            "routes": [
              {
                "name": "BV消耗分析",
                "access": "routeFilter",
                "path": "/kanban/bv-spend-analysis",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Kanban__Bluevision__SpendAnalysis' */'/home/gitlab-runner/builds/QXiX3rkE/0/bluevision/bv_crm_web/src/pages/Kanban/Bluevision/SpendAnalysis'), loading: LoadingComponent}),
                "exact": true
              },
              {
                "name": "FB大盘日报",
                "access": "routeFilter",
                "path": "/kanban/fb-entirety-daily",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Kanban__Facebook__EntiretyDaily' */'/home/gitlab-runner/builds/QXiX3rkE/0/bluevision/bv_crm_web/src/pages/Kanban/Facebook/EntiretyDaily'), loading: LoadingComponent}),
                "exact": true
              },
              {
                "name": "BV谷歌大盘日报",
                "access": "routeFilter",
                "path": "/kanban/bv-entirety-daily",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Kanban__Bluevision__EntiretyDaily' */'/home/gitlab-runner/builds/QXiX3rkE/0/bluevision/bv_crm_web/src/pages/Kanban/Bluevision/EntiretyDaily'), loading: LoadingComponent}),
                "exact": true
              },
              {
                "name": "FB大盘对比",
                "access": "routeFilter",
                "path": "/kanban/fb-entirety-comparison",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Kanban__Facebook__EntiretyComparison' */'/home/gitlab-runner/builds/QXiX3rkE/0/bluevision/bv_crm_web/src/pages/Kanban/Facebook/EntiretyComparison'), loading: LoadingComponent}),
                "exact": true
              },
              {
                "name": "BV消耗预测&销售KPI跟踪",
                "access": "routeFilter",
                "path": "/kanban/bv-spend-forecast",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Kanban__Bluevision__SpendForecast' */'/home/gitlab-runner/builds/QXiX3rkE/0/bluevision/bv_crm_web/src/pages/Kanban/Bluevision/SpendForecast'), loading: LoadingComponent}),
                "exact": true
              },
              {
                "name": "FB KPI监测",
                "access": "routeFilter",
                "path": "/kanban/kpi-monitoring",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Kanban__KpiMonitoring' */'/home/gitlab-runner/builds/QXiX3rkE/0/bluevision/bv_crm_web/src/pages/Kanban/KpiMonitoring'), loading: LoadingComponent}),
                "exact": true
              }
            ]
          },
          {
            "name": "行业看板",
            "path": "/industry",
            "icon": "line-chart",
            "routes": [
              {
                "name": "GAME",
                "access": "routeFilter",
                "path": "/industry/game",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Kanban__Industry__Game' */'/home/gitlab-runner/builds/QXiX3rkE/0/bluevision/bv_crm_web/src/pages/Kanban/Industry/Game'), loading: LoadingComponent}),
                "exact": true
              },
              {
                "name": "EC",
                "access": "routeFilter",
                "path": "/industry/ec",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Kanban__Industry__Ec' */'/home/gitlab-runner/builds/QXiX3rkE/0/bluevision/bv_crm_web/src/pages/Kanban/Industry/Ec'), loading: LoadingComponent}),
                "exact": true
              },
              {
                "name": "APP",
                "access": "routeFilter",
                "path": "/industry/app",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Kanban__Industry__App' */'/home/gitlab-runner/builds/QXiX3rkE/0/bluevision/bv_crm_web/src/pages/Kanban/Industry/App'), loading: LoadingComponent}),
                "exact": true
              },
              {
                "name": "BRANDING",
                "access": "routeFilter",
                "path": "/industry/branding",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Kanban__Industry__Branding' */'/home/gitlab-runner/builds/QXiX3rkE/0/bluevision/bv_crm_web/src/pages/Kanban/Industry/Branding'), loading: LoadingComponent}),
                "exact": true
              },
              {
                "name": "FIN",
                "access": "routeFilter",
                "path": "/industry/fin",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Kanban__Industry__Fin' */'/home/gitlab-runner/builds/QXiX3rkE/0/bluevision/bv_crm_web/src/pages/Kanban/Industry/Fin'), loading: LoadingComponent}),
                "exact": true
              }
            ]
          },
          {
            "name": "品牌客户设置",
            "path": "/account",
            "icon": "bars",
            "routes": [
              {
                "name": "分配客户",
                "access": "routeFilter",
                "path": "/account/agent",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__AccountSetting__Agent' */'/home/gitlab-runner/builds/QXiX3rkE/0/bluevision/bv_crm_web/src/pages/AccountSetting/Agent'), loading: LoadingComponent}),
                "exact": true
              },
              {
                "name": "客户信息",
                "access": "routeFilter",
                "path": "/account/account",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__AccountSetting__Account' */'/home/gitlab-runner/builds/QXiX3rkE/0/bluevision/bv_crm_web/src/pages/AccountSetting/Account'), loading: LoadingComponent}),
                "exact": true
              }
            ]
          },
          {
            "name": "品牌知识中心",
            "path": "/knowledge",
            "icon": "credit-card",
            "routes": [
              {
                "name": "媒体介绍",
                "access": "routeFilter",
                "path": "/knowledge/media-info",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__KnowledgeCenter__MediaInfo' */'/home/gitlab-runner/builds/QXiX3rkE/0/bluevision/bv_crm_web/src/pages/KnowledgeCenter/MediaInfo'), loading: LoadingComponent}),
                "exact": true
              },
              {
                "name": "",
                "access": "knowledgeRouteFilter",
                "path": "/knowledge/media-info/:id",
                "hideInMenu": true,
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__KnowledgeCenter__MediaInfo__Detail' */'/home/gitlab-runner/builds/QXiX3rkE/0/bluevision/bv_crm_web/src/pages/KnowledgeCenter/MediaInfo/Detail'), loading: LoadingComponent}),
                "exact": true
              },
              {
                "name": "媒体产品更新",
                "access": "routeFilter",
                "path": "/knowledge/media-product-update",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__KnowledgeCenter__MediaProductUpdate' */'/home/gitlab-runner/builds/QXiX3rkE/0/bluevision/bv_crm_web/src/pages/KnowledgeCenter/MediaProductUpdate'), loading: LoadingComponent}),
                "exact": true
              },
              {
                "name": "",
                "access": "knowledgeRouteFilter",
                "path": "/knowledge/media-product-update/:id",
                "hideInMenu": true,
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__KnowledgeCenter__MediaProductUpdate__Detail' */'/home/gitlab-runner/builds/QXiX3rkE/0/bluevision/bv_crm_web/src/pages/KnowledgeCenter/MediaProductUpdate/Detail'), loading: LoadingComponent}),
                "exact": true
              },
              {
                "name": "行业基础",
                "access": "routeFilter",
                "path": "/knowledge/basic-indicators",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__KnowledgeCenter__BasicIndicators' */'/home/gitlab-runner/builds/QXiX3rkE/0/bluevision/bv_crm_web/src/pages/KnowledgeCenter/BasicIndicators'), loading: LoadingComponent}),
                "exact": true
              },
              {
                "name": "",
                "access": "knowledgeRouteFilter",
                "path": "/knowledge/basic-indicators/:id",
                "hideInMenu": true,
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__KnowledgeCenter__BasicIndicators__Detail' */'/home/gitlab-runner/builds/QXiX3rkE/0/bluevision/bv_crm_web/src/pages/KnowledgeCenter/BasicIndicators/Detail'), loading: LoadingComponent}),
                "exact": true
              },
              {
                "name": "行业洞察",
                "access": "routeFilter",
                "path": "/knowledge/industry-benchmark",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__KnowledgeCenter__IndustryBenchmark' */'/home/gitlab-runner/builds/QXiX3rkE/0/bluevision/bv_crm_web/src/pages/KnowledgeCenter/IndustryBenchmark'), loading: LoadingComponent}),
                "exact": true
              },
              {
                "name": "",
                "access": "knowledgeRouteFilter",
                "path": "/knowledge/industry-benchmark/:id",
                "hideInMenu": true,
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__KnowledgeCenter__IndustryBenchmark__Detail' */'/home/gitlab-runner/builds/QXiX3rkE/0/bluevision/bv_crm_web/src/pages/KnowledgeCenter/IndustryBenchmark/Detail'), loading: LoadingComponent}),
                "exact": true
              }
            ]
          },
          {
            "name": "Tiktok广告审核",
            "path": "/tiktokAd",
            "icon": "schedule",
            "routes": [
              {
                "name": "待巡查",
                "access": "routeFilter",
                "path": "/tiktokAd/nocheck",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__TiktokAd__NoCheck' */'/home/gitlab-runner/builds/QXiX3rkE/0/bluevision/bv_crm_web/src/pages/TiktokAd/NoCheck'), loading: LoadingComponent}),
                "exact": true
              },
              {
                "name": "待整改",
                "access": "routeFilter",
                "path": "/tiktokAd/nomodify",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__TiktokAd__NoModify' */'/home/gitlab-runner/builds/QXiX3rkE/0/bluevision/bv_crm_web/src/pages/TiktokAd/NoModify'), loading: LoadingComponent}),
                "exact": true
              },
              {
                "name": "已整改",
                "access": "routeFilter",
                "path": "/tiktokAd/rectified",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__TiktokAd__Rectified' */'/home/gitlab-runner/builds/QXiX3rkE/0/bluevision/bv_crm_web/src/pages/TiktokAd/Rectified'), loading: LoadingComponent}),
                "exact": true
              },
              {
                "name": "正常",
                "access": "routeFilter",
                "path": "/tiktokAd/normal",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__TiktokAd__Normal' */'/home/gitlab-runner/builds/QXiX3rkE/0/bluevision/bv_crm_web/src/pages/TiktokAd/Normal'), loading: LoadingComponent}),
                "exact": true
              },
              {
                "name": "我负责的广告",
                "access": "routeFilter",
                "path": "/tiktokAd/myAds",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__TiktokAd__MyAds' */'/home/gitlab-runner/builds/QXiX3rkE/0/bluevision/bv_crm_web/src/pages/TiktokAd/MyAds'), loading: LoadingComponent}),
                "exact": true
              },
              {
                "name": "账户分类",
                "access": "routeFilter",
                "path": "/tiktokAd/accounts",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__TiktokAd__Accounts' */'/home/gitlab-runner/builds/QXiX3rkE/0/bluevision/bv_crm_web/src/pages/TiktokAd/Accounts'), loading: LoadingComponent}),
                "exact": true
              }
            ]
          },
          {
            "name": "工具类",
            "path": "/tools",
            "icon": "calculator",
            "routes": [
              {
                "name": "任务中心",
                "access": "routeFilter",
                "path": "/tools/task",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Tools__TaskCenter' */'/home/gitlab-runner/builds/QXiX3rkE/0/bluevision/bv_crm_web/src/pages/Tools/TaskCenter'), loading: LoadingComponent}),
                "icon": "pay-circle",
                "exact": true
              },
              {
                "name": "TT数据查询",
                "access": "routeFilter",
                "path": "/tools/tt-query",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Tools__TtQuery' */'/home/gitlab-runner/builds/QXiX3rkE/0/bluevision/bv_crm_web/src/pages/Tools/TtQuery'), loading: LoadingComponent}),
                "icon": "pay-circle",
                "exact": true
              },
              {
                "name": "Fb数据查询",
                "access": "routeFilter",
                "path": "/tools/query",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Tools__FbQuery' */'/home/gitlab-runner/builds/QXiX3rkE/0/bluevision/bv_crm_web/src/pages/Tools/FbQuery'), loading: LoadingComponent}),
                "icon": "pay-circle",
                "exact": true
              },
              {
                "name": "FB广告信息查询",
                "access": "routeFilter",
                "path": "/tools/ad-query",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Tools__FbAdQuery' */'/home/gitlab-runner/builds/QXiX3rkE/0/bluevision/bv_crm_web/src/pages/Tools/FbAdQuery'), loading: LoadingComponent}),
                "icon": "pay-circle",
                "exact": true
              },
              {
                "name": "自助服务台",
                "access": "routeFilter",
                "path": "/tools/self-service",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Tools__SelfService' */'/home/gitlab-runner/builds/QXiX3rkE/0/bluevision/bv_crm_web/src/pages/Tools/SelfService'), loading: LoadingComponent}),
                "icon": "pay-circle",
                "exact": true
              },
              {
                "name": "TikTok白名单",
                "path": "/tools/tiktok-whitelist",
                "access": "routeFilter",
                "hideInMenu": true,
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Tools__SelfService__TikTokWhiteList' */'/home/gitlab-runner/builds/QXiX3rkE/0/bluevision/bv_crm_web/src/pages/Tools/SelfService/TikTokWhiteList'), loading: LoadingComponent}),
                "exact": true
              },
              {
                "name": "信息变更记录",
                "path": "/tools/info-change-record",
                "access": "routeFilter",
                "hideInMenu": true,
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Tools__SelfService__InfoChangeRecord' */'/home/gitlab-runner/builds/QXiX3rkE/0/bluevision/bv_crm_web/src/pages/Tools/SelfService/InfoChangeRecord'), loading: LoadingComponent}),
                "exact": true
              },
              {
                "name": "被封池提速",
                "path": "/tools/pool-accelerate",
                "access": "routeFilter",
                "hideInMenu": true,
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Tools__SelfService__PoolAccelerate' */'/home/gitlab-runner/builds/QXiX3rkE/0/bluevision/bv_crm_web/src/pages/Tools/SelfService/PoolAccelerate'), loading: LoadingComponent}),
                "exact": true
              },
              {
                "name": "错误提示配置",
                "path": "/tools/code-info-config",
                "access": "routeFilter",
                "hideInMenu": true,
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Tools__SelfService__CodeInfoConfig' */'/home/gitlab-runner/builds/QXiX3rkE/0/bluevision/bv_crm_web/src/pages/Tools/SelfService/CodeInfoConfig'), loading: LoadingComponent}),
                "exact": true
              },
              {
                "name": "鲁班获客渠道",
                "path": "/tools/luban-customer-source",
                "access": "routeFilter",
                "hideInMenu": true,
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Tools__SelfService__LubanCustomerSource' */'/home/gitlab-runner/builds/QXiX3rkE/0/bluevision/bv_crm_web/src/pages/Tools/SelfService/LubanCustomerSource'), loading: LoadingComponent}),
                "exact": true
              },
              {
                "name": "钱包冻结解冻",
                "path": "/tools/wallet-freeze-thaw",
                "access": "routeFilter",
                "hideInMenu": true,
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Tools__SelfService__WalletFreezeThaw' */'/home/gitlab-runner/builds/QXiX3rkE/0/bluevision/bv_crm_web/src/pages/Tools/SelfService/WalletFreezeThaw'), loading: LoadingComponent}),
                "exact": true
              },
              {
                "name": "客户反馈（VL + Publisher）",
                "path": "/tools/feedback",
                "access": "routeFilter",
                "hideInMenu": true,
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Tools__SelfService__Feedback' */'/home/gitlab-runner/builds/QXiX3rkE/0/bluevision/bv_crm_web/src/pages/Tools/SelfService/Feedback'), loading: LoadingComponent}),
                "exact": true
              }
            ]
          },
          {
            "name": "权限管理",
            "path": "/administration",
            "icon": "setting",
            "routes": [
              {
                "name": "业务单元",
                "access": "routeFilter",
                "path": "/administration/unit",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Administration__Unit' */'/home/gitlab-runner/builds/QXiX3rkE/0/bluevision/bv_crm_web/src/pages/Administration/Unit'), loading: LoadingComponent}),
                "exact": true
              },
              {
                "name": "财务配置",
                "access": "routeFilter",
                "path": "/administration/unit/financial-config/:id/:name",
                "hideInMenu": true,
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Administration__Unit__modules__FinancialConfig' */'/home/gitlab-runner/builds/QXiX3rkE/0/bluevision/bv_crm_web/src/pages/Administration/Unit/modules/FinancialConfig'), loading: LoadingComponent}),
                "exact": true
              },
              {
                "name": "用户管理",
                "access": "routeFilter",
                "path": "/administration/user",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Administration__User' */'/home/gitlab-runner/builds/QXiX3rkE/0/bluevision/bv_crm_web/src/pages/Administration/User'), loading: LoadingComponent}),
                "exact": true
              },
              {
                "name": "菜单管理",
                "access": "routeFilter",
                "path": "/administration/menu",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Administration__Menu' */'/home/gitlab-runner/builds/QXiX3rkE/0/bluevision/bv_crm_web/src/pages/Administration/Menu'), loading: LoadingComponent}),
                "exact": true
              },
              {
                "name": "角色管理",
                "access": "routeFilter",
                "path": "/administration/role",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Administration__Role' */'/home/gitlab-runner/builds/QXiX3rkE/0/bluevision/bv_crm_web/src/pages/Administration/Role'), loading: LoadingComponent}),
                "exact": true
              },
              {
                "name": "黑白名单规则权限",
                "access": "routeFilter",
                "path": "/administration/black-white-control",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Administration__BlackWhiteControl' */'/home/gitlab-runner/builds/QXiX3rkE/0/bluevision/bv_crm_web/src/pages/Administration/BlackWhiteControl'), loading: LoadingComponent}),
                "exact": true
              },
              {
                "name": "AE 查看销售权限",
                "path": "/administration/ae-sale-access",
                "access": "routeFilter",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Tools__SelfService__AeSaleAccess' */'/home/gitlab-runner/builds/QXiX3rkE/0/bluevision/bv_crm_web/src/pages/Tools/SelfService/AeSaleAccess'), loading: LoadingComponent}),
                "exact": true
              }
            ]
          },
          {
            "name": "监控预警",
            "path": "/monitor",
            "icon": "calculator",
            "routes": [
              {
                "name": "余额预警",
                "path": "/monitor/balance-warning",
                "access": "routeFilter",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Monitor__BalanceWarning' */'/home/gitlab-runner/builds/QXiX3rkE/0/bluevision/bv_crm_web/src/pages/Monitor/BalanceWarning'), loading: LoadingComponent}),
                "exact": true
              },
              {
                "name": "消耗预警",
                "path": "/monitor/allocation-consumption-limit",
                "access": "routeFilter",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Monitor__ConsumptionLimit' */'/home/gitlab-runner/builds/QXiX3rkE/0/bluevision/bv_crm_web/src/pages/Monitor/ConsumptionLimit'), loading: LoadingComponent}),
                "exact": true
              },
              {
                "name": "",
                "path": "/monitor/allocation-consumption-limit-detail/:id",
                "access": "routeFilter",
                "hideInMenu": true,
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Monitor__ConsumptionLimit__ConsumptionLimitDetail' */'/home/gitlab-runner/builds/QXiX3rkE/0/bluevision/bv_crm_web/src/pages/Monitor/ConsumptionLimit/ConsumptionLimitDetail'), loading: LoadingComponent}),
                "exact": true
              },
              {
                "name": "盗刷预警",
                "path": "/monitor/theft-warning",
                "access": "routeFilter",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Monitor__TheftWarning' */'/home/gitlab-runner/builds/QXiX3rkE/0/bluevision/bv_crm_web/src/pages/Monitor/TheftWarning'), loading: LoadingComponent}),
                "exact": true
              }
            ]
          },
          {
            "name": "BlueAff",
            "path": "/blueaff",
            "icon": "bars",
            "access": "routeFilter",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__BlueAff' */'/home/gitlab-runner/builds/QXiX3rkE/0/bluevision/bv_crm_web/src/pages/BlueAff'), loading: LoadingComponent}),
            "exact": true
          },
          {
            "name": "黑白名单配置",
            "path": "/blackWhiteList",
            "icon": "FileTextOutlined",
            "routes": [
              {
                "path": "/blackWhiteList",
                "redirect": "/blackWhiteList/rule",
                "access": "routeFilter",
                "exact": true
              },
              {
                "name": "黑白名单规则",
                "path": "/blackWhiteList/rule",
                "access": "routeFilter",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__BlackWhiteList' */'/home/gitlab-runner/builds/QXiX3rkE/0/bluevision/bv_crm_web/src/pages/BlackWhiteList'), loading: LoadingComponent}),
                "exact": true
              },
              {
                "name": "黑白名单规则详情",
                "path": "/blackWhiteList/rule/detail",
                "access": "routeFilter",
                "hideInMenu": true,
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__BlackWhiteList__Detail' */'/home/gitlab-runner/builds/QXiX3rkE/0/bluevision/bv_crm_web/src/pages/BlackWhiteList/Detail'), loading: LoadingComponent}),
                "exact": true
              }
            ]
          },
          {
            "name": "MetaRCMP",
            "path": "/meta-rcmp",
            "icon": "aim",
            "routes": [
              {
                "name": "账户池",
                "access": "routeFilter",
                "path": "/meta-rcmp/account-pool",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Tools__FbAdGuide' */'/home/gitlab-runner/builds/QXiX3rkE/0/bluevision/bv_crm_web/src/pages/Tools/FbAdGuide'), loading: LoadingComponent}),
                "icon": "pay-circle",
                "exact": true
              },
              {
                "name": "添加账户",
                "access": "routeFilter",
                "path": "/meta-rcmp/account-pool/add-account",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Tools__FbAdGuide__addFbAccount' */'/home/gitlab-runner/builds/QXiX3rkE/0/bluevision/bv_crm_web/src/pages/Tools/FbAdGuide/addFbAccount'), loading: LoadingComponent}),
                "icon": "pay-circle",
                "hideInMenu": true,
                "exact": true
              },
              {
                "name": "ALM机会分数",
                "access": "routeFilter",
                "path": "/meta-rcmp/fb-ad-guide",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__MetaRcmp__AlmOpportunityScore' */'/home/gitlab-runner/builds/QXiX3rkE/0/bluevision/bv_crm_web/src/pages/MetaRcmp/AlmOpportunityScore'), loading: LoadingComponent}),
                "icon": "pay-circle",
                "exact": true
              }
            ]
          },
          {
            "name": "批量操作",
            "path": "/batch/:module",
            "isExact": false,
            "hideInMenu": true,
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'components__CBatchOperation' */'/home/gitlab-runner/builds/QXiX3rkE/0/bluevision/bv_crm_web/src/components/CBatchOperation'), loading: LoadingComponent}),
            "exact": true
          },
          {
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__404' */'/home/gitlab-runner/builds/QXiX3rkE/0/bluevision/bv_crm_web/src/pages/404'), loading: LoadingComponent}),
            "exact": true
          }
        ]
      },
      {
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__404' */'/home/gitlab-runner/builds/QXiX3rkE/0/bluevision/bv_crm_web/src/pages/404'), loading: LoadingComponent}),
        "exact": true
      }
    ]
  }
];

  // allow user to extend routes
  plugin.applyPlugins({
    key: 'patchRoutes',
    type: ApplyPluginsType.event,
    args: { routes },
  });

  return routes;
}
